// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".product-accordion[data-v-3bfa5d7e] b{font-weight:800}.product-accordion[data-v-3bfa5d7e] .ota-p18{font-size:1.5rem}.right-flex[data-v-3bfa5d7e]{max-width:75rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
